import React, { useEffect } from 'react';
import { Box, Stack, HStack, Text, useColorMode } from '@chakra-ui/react';

import { i_h3 } from '../../../style';
import { StatsCard } from './components/StatsCard';
import { VeNFTList } from './components/VeNFTList';
import PageHeader from '../../../components/PageHeader/PageHeader';
import PageLayout from '../../../components/layout/PageLayout';
import NetworkSelect from '../../../components/Select/NetworkSelect/NetworkSelect';
import ValidBlockWrapper from '../../components/ChainNotValidBlock';
import { getColorThemeSelector } from '../../../iZUMi-UI-toolkit/src/utils/funcs';
import WalletButton from '../../../components/Buttons/WalletButton/WalletButton';
import { useTranslation } from 'react-i18next';
import useIsMobile from '../../../iZUMi-UI-toolkit/src/hooks/useIsMobile';
import VeTokenLinkButton from '../../../components/Buttons/veTokenLinkButton/veTokenLinkButton';

const Locker: React.FC = () => {
    useEffect(() => {
        document.title = 'veARC | Arctic';
    }, []);
    const { t } = useTranslation();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const isMobile = useIsMobile();

    return isMobile ? (
        <PageLayout
            body={
                <ValidBlockWrapper
                    content={
                        <Stack w="100%" pt={{ base: '20px', sm: '0px' }} pb={{ base: '70px', sm: '0px' }}>
                            <Box h="20px" />
                            <StatsCard />
                            <VeNFTList />
                        </Stack>
                    }
                    app="veToken"
                />
            }
            type="mobile"
        />
    ) : (
        <PageLayout
            header={
                <PageHeader
                    headerTitle={t('Create New veARC')}
                    subtitle={t('Lock your ARC to acquire veARC. More veARC, more voting power!')}
                    element={
                        <HStack spacing="10px">
                            <VeTokenLinkButton />
                            <NetworkSelect />
                        </HStack>
                    }
                />
            }
            body={
                <ValidBlockWrapper
                    content={
                        <Stack w="100%" pt={{ base: '20px', sm: '0px' }} pb={{ base: '70px', sm: '0px' }}>
                            <Box h="20px" />
                            <StatsCard />
                            <VeNFTList />
                        </Stack>
                    }
                    app="veToken"
                />
            }
            internalWidth={{ base: '100%', sm: '700px', xl: '840px', xxl: '1100px', xlp1: '1150px' }}
            mobileAdapt={true}
        />
    );
};

export default Locker;
